"use client";

import { cn } from "@marketing-sites/utils/cn";
import { Text } from "@/components/atoms/text";
import { Link } from "@marketing-sites/ui/primitives";
import { useLocalizedHref } from "@/lib/l10n/providers";

export const Breadcrumb = ({
  title,
  linkMetadata,
  sectionMetadata,
  className,
}: {
  title: string;
  linkMetadata: { analyticsId: string };
  sectionMetadata: { analyticsId: string };
  className?: string;
}) => {
  const localizeHref = useLocalizedHref();

  return (
    <div
      className={cn("mb-9 flex items-center gap-2 md:mb-12", className)}
      data-analytics-region="Breadcrumb"
      data-analytics-id={sectionMetadata.analyticsId}
    >
      <Text anchor animateIn asChild className="text-black/80">
        <Link
          analyticsId={linkMetadata.analyticsId}
          href={localizeHref("/learning-center")}
        >
          Learning Center
        </Link>
      </Text>
      <span className="text-sm text-black/30">›</span>
      <Text asChild className="truncate text-black/60">
        <span>{title}</span>
      </Text>
    </div>
  );
};
